(function() {

    "use strict";

    angular
        .module('ATMGurus')
        .filter('splitBy', splitBy);

    function splitBy() {

        return function(string, splitter) {
            if (!string) return;
            return string.split(splitter).join(' ');
        }

    }
})()


// WEBPACK FOOTER //
// ./src/app/filters/splitBy.js